import Script from 'next/script';

const SpiffScript: React.FC = () => (
    <Script
        id="SpiffAPI"
        type="text/javascript"
        strategy="lazyOnload"
        src="https://assets.us.spiffcommerce.com/api.js"
    />
);

export default SpiffScript;
